// components/Header.js
import React, { useState } from "react";
import "./Header.css";
import logoImage from "../image/kadaipos_logo_transparent.png";

const Header = ({ cartCount }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleScroll = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="nav">
          {/* Logo */}
          <div className="logo">
            <img src={logoImage} alt="KadaiPOS Logo" className="logo-image" />
          </div>

          {/* Hamburger Menu Icon */}
          <div className="hamburger" onClick={toggleMenu}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>

          {/* Dark overlay */}
          {isMenuOpen && <div className="overlay" onClick={toggleMenu}></div>}

          {/* Navigation Menu */}
          <nav className={`nav-menu ${isMenuOpen ? "active" : ""}`}>
            <a href="#features" onClick={(e) => handleScroll(e, "features")}>
              Features
            </a>
            <a href="#pricing" onClick={(e) => handleScroll(e, "pricing")}>
              Pricing
            </a>
            <a
              href="#testimonials"
              onClick={(e) => handleScroll(e, "testimonials")}
            >
              Testimonials
            </a>
            <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
              FAQ
            </a>
            <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
              Contact
            </a>

            {/* Mobile "Get Started" button */}
            <button
              className="btn btn-primary mobile-get-started"
              onClick={(e) => handleScroll(e, "contact")}
            >
              Get Started
            </button>
          </nav>

          {/* Cart + Button (desktop only) */}
          <div className="nav-actions">
            <div className="cart-icon">
              <i className="fas fa-shopping-cart"></i>
              {cartCount > 0 && (
                <span className="cart-count">{cartCount}</span>
              )}
            </div>
            <button
              className="btn btn-primary"
              onClick={(e) => handleScroll(e, "contact")}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
